const styles = theme => ({
  popper: {
    zIndex: theme.zIndex.modal,
  },
  popup: {
    borderRadius: '12px',
    backgroundColor: theme.palette.background.paper,
    overflow: 'hidden',
    animation: '$slideIn 0.2s ease-out',
  },
  '@keyframes slideIn': {
    '0%': {
      opacity: 0,
      transform: 'scale(0.95) translateY(-10px)',
    },
    '100%': {
      opacity: 1,
      transform: 'scale(1) translateY(0)',
    },
  },
})

export default styles
